export const formatDurationOrDash = (seconds: number | null | undefined): string => {
  if (seconds === null || seconds === undefined) return '—';
  if (seconds < 60) return `${Math.round(seconds)}s`;

  const totalMinutes = Math.floor(seconds / 60);
  const hours = Math.floor(totalMinutes / 60);
  const minutes = totalMinutes % 60;

  if (hours === 0) return `${minutes}m`;
  return minutes === 0 ? `${hours}h` : `${hours}h ${minutes}m`;
};

export const formatRateOrDash = (value: number | null | undefined): string =>
  value === null || value === undefined ? '—' : `${Math.round(value * 10) / 10}%`;

export const formatScoreOrDash = (value: number | null | undefined): string =>
  value === null || value === undefined ? '—' : String(Math.round(value * 10) / 10);
